export default "__VITE_ASSET__DPHT8UBQ__"